import { US_TYPES } from '../usCodegen';
import { catalogFor } from './orderingModel';

export const orderingColumn = (kind, key, selected = '') => {
  const field = US_TYPES[kind].fields.find(f => f.key === key);
  const options = field.options.map(o => ({ ...o, code: kind === 'housing' && key === 'W' ? o.code.padStart(3, '0') : o.code, enabled: true }));
  return { id: key, title: field.label.replace(' (unpadded)', '').toUpperCase(), selected: selected || options[0]?.code || '', options };
};
const group = (id, label, ...columns) => ({ id, label, enabled: true, columns });
export const hangerGroup = () => group('hanger', 'HARDWARE', { id: 'HB', title: 'HARDWARE', selected: 'HB', options: [{ code: 'HB', label: 'Hanger bars', enabled: true }, { code: 'NB', label: 'No hanger bars', enabled: true }] });

export function orderingPreset(kind, keep = {}) {
  const c = (key, selected) => orderingColumn(kind, key, selected);
  let o;
  if (kind === 'housing') {
    o = { title: 'HOUSING ORDERING INFORMATION', intro: 'Trims are ordered separately.', groups: [
      { id: 'series', label: 'SERIES', prefix: 'H', decode: 'H Housing', columns: [] },
      group('aperture', 'APERTURE', c('P', 'R'), c('Z', '40')),
      group('style', 'HOUSING STYLE', c('Y', 'IH')),
      hangerGroup(),
      group('collar', 'COLLAR', c('C', 'D')),
      group('wattage', 'WATTAGE', c('W', '015')),
      group('dimming', 'DIMMING', c('D', 'D2')),
      group('voltage', 'VOLTAGE', c('V', 'UNV')),
      group('listing', "ADD'L LISTING", c('A', 'NR')),
      { ...group('dimensions', 'HOUSING DIMENSIONS', c('H')), enabled: false },
      { ...group('lamps', 'NUMBER OF LEDS', c('L')), enabled: false },
    ], notes: [] };
  } else if (kind === 'track') {
    o = { title: 'FIXTURE ORDERING INFORMATION', intro: '', groups: [
      { id: 'series', label: 'SERIES', prefix: 'T', decode: 'T Track', columns: [] },
      group('family-size', 'FAMILY · SIZE', c('F', 'TEN'), c('Z', 'S')),
      group('adapter', 'ADAPTER', c('P', 'J')),
      group('wattage', 'WATTAGE', c('W', '015')),
      group('cri-cct', 'CRI · COLOUR TEMP', c('CR', '90'), c('CT', '30')),
      group('beam', 'BEAM SPREAD', c('BM', '30')),
      group('finish', 'HOUSING · BAFFLE FINISH', c('F1', 'W'), c('F2', 'B')),
      group('voltage', 'VOLTAGE', c('V', '120')),
    ], notes: ['Track adapter sets the dimming protocol.'] };
  } else {
    o = { title: 'TRIM ORDERING INFORMATION', intro: 'Housing and driver are ordered separately.', groups: [
      group('mounting', 'MOUNTING', c('M', 'R')),
      group('family-size-shape', 'FAMILY · SIZE · SHAPE', c('F', 'POC'), c('Z', 'M'), c('P', 'R')),
      group('baffle-flange', 'BAFFLE · FLANGE STYLE', c('B', 'B'), c('T', 'V')),
      group('mechanism', 'MECHANISM', c('E', 'A')),
      group('wattage', 'WATTAGE', c('W', '015')),
      group('cri-cct', 'CRI · COLOUR TEMP', c('CR', '90'), c('CT', '30')),
      group('beam', 'BEAM SPREAD', c('BM', '24')),
      group('finish', 'FLANGE · BAFFLE FINISH', c('F1', 'N'), c('F2', 'W')),
      group('accessory', 'BAFFLE ACCESSORY', c('A', 'NR')),
      { ...group('dimming', 'DIMMING (OPTIONAL)', c('D', 'D2')), enabled: false },
    ], notes: [] };
  }
  return { ...o, typeKey: kind, optionLibraryVersion: 2, example: catalogFor(o, kind === 'housing' ? 'housing' : 'fixture'), ...keep };
}

export function pocoOrdering({ size = 'M', shape = 'R', baffle = 'B' } = {}) {
  const base = orderingPreset('downlight');
  const allowed = { M: ['R'], F: ['POC'], Z: [size], P: [shape], B: [baffle], E: ['A'], W: ['008', '010', '015', '021'], CR: ['90', '95', '97'] };
  return { ...base, groups: base.groups.map(g => ({ ...g, columns: g.columns.map(c => ({ ...c,
    selected: ['M', 'F', 'Z', 'P', 'B', 'E'].includes(c.id) ? allowed[c.id][0] : c.selected,
    options: c.options.map(o => ({ ...o, enabled: !allowed[c.id] || allowed[c.id].includes(o.code) })),
  })) })) };
}
export const FIXTURE_PRESETS = [{ key: 'downlight', label: 'Full downlight template' }, { key: 'track', label: 'Full track template' }];
export const HOUSING_PRESETS = [{ key: 'housing', label: 'Full housing template' }];